import { SET_PLAY_LOGS, SetPlayLogsAction } from "./actions"
import { Playlogs } from "../lib/playlogs"
import { StoreAction } from "../../../types/store"

export interface StoreState {
  playlogs: Playlogs[]
}

export const initialState: StoreState = {
  playlogs: [],
}

export default function reducer(state: StoreState, action: StoreAction): StoreState {
  switch (action.type) {
    case SET_PLAY_LOGS: {
      const { playlogs } = action as SetPlayLogsAction
      return {
        ...state,
        playlogs,
      }
    }

    default:
      return state
  }
}
